const PhoneOrder = ({ color = '#2D264B' }: { color?: string }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18.3639 11.1924V10.6267C18.3639 10.5421 18.3639 10.4997 18.3634 10.4639C18.3247 7.75855 16.1409 5.57479 13.4355 5.53605C13.3997 5.53553 13.3574 5.53553 13.2728 5.53553H12.7071M21.8996 11.8995V10.9095C21.8996 10.0649 21.8996 9.64258 21.8677 9.28659C21.5226 5.43191 18.4677 2.37699 14.613 2.03187C14.257 2 13.8347 2 12.99 2L12.0001 2M8.77785 9.22339C8.32461 10.2632 8.554 11.4744 9.35605 12.2765L11.7529 14.6733C12.5549 15.4753 13.7661 15.7047 14.8059 15.2515C15.8457 14.7982 17.057 15.0276 17.859 15.8297L19.3172 17.2879C19.3878 17.3585 19.4232 17.3938 19.4518 17.425C20.1548 18.1901 20.1548 19.3662 19.4518 20.1314C19.4232 20.1625 19.3878 20.1978 19.3172 20.2685L18.4309 21.1548C17.7091 21.8766 16.6685 22.1796 15.6721 21.9582C8.88248 20.4494 3.57995 15.1468 2.07115 8.35725C1.84971 7.36079 2.15272 6.32026 2.87451 5.59846L3.76085 4.71212C3.8315 4.64147 3.86682 4.60615 3.89794 4.57756C4.6631 3.87448 5.83921 3.87448 6.60436 4.57756C6.63548 4.60615 6.67081 4.64147 6.74145 4.71212L8.19965 6.17032C9.0017 6.97237 9.23109 8.18361 8.77785 9.22339Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default PhoneOrder;
